import axios from "axios";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export async function api_SyncPhotos_Reach_Part7(options, logout) {
  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/api_SyncPhotos_Reach_Part7",
      {
        options: options,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }
    console.log("Response Data: ", response);
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
